import AnswersAccordeon from './AnswersAccordeon';

export default AnswersAccordeon;
